import type { Namespace } from "@/i18n/types";
import nsDialogEN from "./en";
import nsDialogJA from "./ja";

export const nsDialog = {
  name: "dialog",
  locales: {
    ja: nsDialogJA,
    en: nsDialogEN,
  },
} satisfies Namespace<"dialog", typeof nsDialogJA>;
